import { FETCH_OTP_VERIFIED_DELIVERY_CHARGES_SUCCESS, FETCH_OTP_VERIFIED_DELIVERY_CHARGES_REQUEST, FETCH_OTP_VERIFIED_DELIVERY_CHARGES_FAILURE, FETCH_OTP_VERIFIED_DELIVERY_CHARGES_RESET } from "@/redux/actions/VasCharges/getOtpVerifiedDeliveryCharges";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getOTPverifiedDeliveryChargesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_OTP_VERIFIED_DELIVERY_CHARGES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_OTP_VERIFIED_DELIVERY_CHARGES_REQUEST:
            return Object.assign({}, state);
        case FETCH_OTP_VERIFIED_DELIVERY_CHARGES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_OTP_VERIFIED_DELIVERY_CHARGES_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getOTPverifiedDeliveryChargesReducer;
